import { toggleIsLoading } from './loading'
import modalActions from './modal';
import messageActions from './message'
import promotionConstants from '../constants/promotion';
import promotionService from '../services/promotion';

const promotionActions = {}

const promotionCreate = (detail) => ({ type: promotionConstants.CREATE_PROMOTION, detail })
const promotionList = (data) => ({ type: promotionConstants.LIST_PROMOTION, data })
const promotionRetrieve = (detail) => ({ type: promotionConstants.RETRIEVE_PROMOTION, detail })
const promotionUpdate = (detail) => ({ type: promotionConstants.UPDATE_PROMOTION, detail })
const promotionDeactivate = (detail) => ({ type: promotionConstants.DEACTIVEATE_PROMOTION, detail })
const promotionActivate = (detail) => ({ type: promotionConstants.ACTIVEATE_PROMOTION, detail })
const promotionClear = () => ({ type: promotionConstants.CLEAR_PROMOTION });

promotionActions.clearPromotion = () => {
  return (dispatch) => {
    dispatch(promotionClear())
  }
}

promotionActions.list = (vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    promotionService.list(vendorApiKey, locationApiKey)
    .then((response) => {
      dispatch(promotionList(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

promotionActions.retrieve = (vendorApiKey, locationApiKey, promotionApiKey, resolve=false) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    promotionService.retrieve(vendorApiKey, locationApiKey, promotionApiKey)
    .then((response) => {
      dispatch(promotionRetrieve(response));
      dispatch(toggleIsLoading(false));
      if (resolve) resolve(response);
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

promotionActions.create = (body, vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    promotionService.create(body, vendorApiKey, locationApiKey)
    .then((response) => {
      dispatch(promotionCreate(response));
      dispatch(toggleIsLoading(false));
      dispatch(modalActions.modalToggle(false));
      dispatch(promotionActions.list(vendorApiKey, locationApiKey));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

promotionActions.update = (body, vendorApiKey, locationApiKey, surveyApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    promotionService.update(body, vendorApiKey, locationApiKey, surveyApiKey)
    .then((response) => {
      dispatch(promotionUpdate(response));
      dispatch(toggleIsLoading(false));
      dispatch(promotionActions.list(vendorApiKey, locationApiKey));
      dispatch(modalActions.modalToggle(false));
      dispatch(modalActions.modalToggle(false))
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

promotionActions.activate = (vendorApiKey, locationApiKey, promotionApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    promotionService.activate(vendorApiKey, locationApiKey, promotionApiKey)
    .then((response) => {
      dispatch(promotionActivate());
      dispatch(toggleIsLoading(false));
      dispatch(promotionActions.list(vendorApiKey, locationApiKey));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

promotionActions.deactivate = (vendorApiKey, locationApiKey, promotionApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    promotionService.deactivate(vendorApiKey, locationApiKey, promotionApiKey)
    .then((response) => {
      dispatch(promotionDeactivate(response));
      dispatch(toggleIsLoading(false));
      dispatch(promotionActions.list(vendorApiKey, locationApiKey));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

export default promotionActions;



/** WEBPACK FOOTER **
 ** ./src/actions/promotion.js
 **/